import TemplateView from '../../TemplateView'
import InformationBlockLine from './InformationBlockLine'

export default class InformationBlock extends TemplateView {
    constructor({
        title = '',
        paragraphs = [],
        additionalClass = '',
    } = {}) {
        super()

        this.title = title
        this.additionalClass = additionalClass

        this.state = {
            paragraphs,
        }

        this.onStatePropertyChanged('paragraphs', () => this._updateParagraphs())
    }

    templateHtml() {
        return '<div class="components_informationBlock <%-additionalClass%>">' +
               '    <div class="title"><%-title%></div>' +
               '    <div class="paragraphsPlaceholder"/>' +
               '    <div class="pointer"></div>' +
               '</div>'
    }

    afterRender() {
        this.find('.title').toggle(!!this.title)
        this.$paragraphsPlaceholder = this.find('.paragraphsPlaceholder')
        this.renderInitialState()
    }

    _updateParagraphs() {
        this.$paragraphsPlaceholder.empty()
        this.state.paragraphs.forEach(paragraph =>
            new InformationBlockLine({
                lineText: paragraph
            }).init(this.$paragraphsPlaceholder)
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/components/informationBlock/InformationBlock.js